module.exports = "/img/36.0fd322.webp";